/**
 * Building Type Config Registry.
 *
 * Central registry for all building type configurations.
 * Each config defines space types, points system, financial channels,
 * optimizer targets, neuroscience labels, and demo data.
 */

import seniorLiving from './seniorLiving';
import healthcare from './healthcare';
import urban from './urban';
import dealerShowroom from './dealerShowroom';

const CONFIGS = {
  seniorLiving,
  brain_health: seniorLiving,  // alias for localStorage project_type key
  healthcare,
  healthcare_facility: healthcare,  // alias
  urban,
  cities_communities: urban,  // alias
  dealerShowroom,
  dealer_showroom: dealerShowroom,  // alias for localStorage project_type key
};

/**
 * Get building type config by type key.
 * Falls back to seniorLiving if type not found.
 */
export const getBuildingConfig = (type) => CONFIGS[type] || seniorLiving;

/**
 * Get all registered building types (deduplicated, no aliases).
 */
export const getAllBuildingTypes = () => [seniorLiving, healthcare, urban, dealerShowroom];

/**
 * Register a new building type at runtime.
 */
export const registerBuildingType = (config) => {
  CONFIGS[config.type] = config;
};

export { seniorLiving, healthcare, urban, dealerShowroom };
